module.exports = __webpack_public_path__ + "static/media/screen-behavioral-05.a27188dc.jpg";